import React from "react";
import { Button } from "@cloudscape-design/components";
import "./RightSidebar.css";

interface RightSidebarProps {
  chatState: "closed" | "default" | "expanded";
  onChatStateChange: (newState: "closed" | "default" | "expanded") => void;
}

const RightSidebar: React.FC<RightSidebarProps> = ({
  chatState,
  onChatStateChange,
}) => {
  const handleOpenChat = () => {
    onChatStateChange("default");
  };

  const handleCloseChat = () => {
    onChatStateChange("closed");
  };

  const handleToggleExpand = () => {
    if (chatState === "default") {
      onChatStateChange("expanded");
    } else if (chatState === "expanded") {
      onChatStateChange("default");
    }
  };

  // When closed, show only the AI icon button
  if (chatState === "closed") {
    return (
      <button
        className="ai-icon-button"
        onClick={handleOpenChat}
        aria-label="Open AI Assistant"
        title="Open AI Assistant"
        style={{
          position: "fixed",
          right: "20px",
          top: "70px",
          width: "60px",
          height: "60px",
          borderRadius: "50%",
          border: "none",
          backgroundColor: "#0073bb",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
          zIndex: 10000,
          fontSize: "32px",
          color: "white",
        }}
      >
        🤖
      </button>
    );
  }

  // When open (default or expanded), show the full chatbot
  return (
    <div
      className={`chat-container ${chatState === "expanded" ? "expanded" : ""}`}
      style={{
        position: "fixed",
        right: 0,
        top: "56px",
        height: "calc(100vh - 56px)",
        zIndex: 999,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        transition: "all 0.3s ease-out",
        backgroundColor: "#ffffff",
        boxShadow: "-2px 0 8px rgba(0, 0, 0, 0.1)",
        width: chatState === "expanded" ? "calc(100vw - 290px)" : "500px",
        left: chatState === "expanded" ? "290px" : "auto",
      }}
    >
      {/* Expand/Collapse button - top left */}
      <button
        className="expand-collapse-button"
        onClick={handleToggleExpand}
        aria-label={chatState === "expanded" ? "Collapse" : "Expand"}
        title={chatState === "expanded" ? "Collapse" : "Expand"}
      >
        {chatState === "expanded" ? (
          <span className="MuiButton-startIcon-531 MuiButton-iconSizeSmall-533">
            <svg
              className="MuiSvgIcon-root-117 VegaSvgIcon"
              focusable="false"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path d="M10.38 13.07A1 1 0 0 0 10 13H4a1 1 0 1 0 0 2h3.59L2.3 20.28a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0L9 16.41V20a1 1 0 0 0 2 0v-6a1 1 0 0 0-.62-.93zM21.7 2.3a1 1 0 0 0-1.42 0L15 7.59V4a1 1 0 1 0-2 0v6a1 1 0 0 0 .07.38 1 1 0 0 0 .55.54.84.84 0 0 0 .38.08h6a1 1 0 0 0 0-2h-3.59l5.29-5.28a1 1 0 0 0 0-1.42z"></path>
              <path fill="none" d="M0 0h24v24H0z"></path>
            </svg>
          </span>
        ) : (
          <span className="MuiButton-startIcon-531 MuiButton-iconSizeSmall-533">
            <svg
              className="MuiSvgIcon-root-117 VegaSvgIcon"
              focusable="false"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path d="M21.92 2.62a1 1 0 0 0-.54-.55A1 1 0 0 0 21 2h-6a1 1 0 0 0 0 2h3.59l-5.3 5.29a1 1 0 1 0 1.42 1.41L20 5.41V9a1 1 0 0 0 2 0V3a1 1 0 0 0-.08-.38zM9.29 13.29 4 18.58V15a1 1 0 0 0-2 0v6a1 1 0 0 0 1 1h6a1 1 0 0 0 0-2H5.41l5.3-5.3a1 1 0 0 0 0-1.41 1 1 0 0 0-1.42 0z"></path>
              <path fill="none" d="M0 0h24v24H0z"></path>
            </svg>
          </span>
        )}
      </button>

      {/* Close button - top right */}
      <div
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          zIndex: 1001,
        }}
      >
        <Button
          iconName="angle-right"
          variant="icon"
          onClick={handleCloseChat}
          ariaLabel="Close AI Assistant"
        />
      </div>

      <div className="chatbot-container">
        <iframe
          src="https://autoreport.lab126.amazon.dev/"
          title="AI Assistant"
          className="chatbot-iframe"
          sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
          loading="lazy"
        />
      </div>
    </div>
  );
};

export default RightSidebar;
